import { Box, Grid, Typography } from '@mui/material';
// import Image from 'next/image';

export interface OurPrinciplesCardProps {
  title: string;
  content: string;
  image: any;
}

export const OurPrinciplesCard = ({
  title,
  content,
  image,
}: OurPrinciplesCardProps) => {
  return (
    <Grid
      item
      display="flex"
      flexDirection="column"
      alignItems="center"
      sx={{ textAlign: 'center' }}
      lg={3}
      sm={6}
      xs={12}
    >
      <Box height={60} display="flex" alignItems="center">
        <img src={image.src} alt={`${title} logo`} />
      </Box>
      <Typography
        component="h4"
        color="#111111"
        // fontSize="18px"
        sx={{
          padding: '10px 0 11px',
          fontSize: {
            xs: 20,
            md: 18,
          },
        }}
        fontWeight={500}
      >
        {title}
      </Typography>
      <Typography
        component="p"
        padding="0 10px"
        color="rgba(17, 17, 17, 0.7)"
        // fontSize={16}
        sx={{
          fontSize: {
            xs: 20,
            md: 16,
          },
          lineHeight: {
            xs: '30px',
            md: '24px',
          },
          py: 0,
          px: {
            xs: 0,
            md: '10px',
          },
        }}
        // lineHeight="24px"
      >
        {content}
      </Typography>
    </Grid>
  );
};
